export const views = ["Front", "Back"]
export const excludeImage = ["Fa", "Fc", "Dc"]
export const topSelection = ["B", "C", "D", "E", "F", "G"]
export const skirtSelection = ["B", "C", "D", "E", "F", "G", "H", "I", "J"]
export const sleevesSelection = ["G", "H", "I"]
export const stripSelection = ["J"]
export const backSelection = ["J", "K", "L"]
export const defaultTop = "Bodice-Front-B1-Da-Ea"
export const defaultTopBack = "Bodice-Back-Ka-La"
export const defaultSkirt = "Skirt-Front-B1-Da-Ga-Ha-Ia"
export const availablePicSet = require('@/assets/topSet.json')
